/**
 * @author: Michal Mlčoch <xmlcoc12@stud.fit.vutbr.cz>
 */

import {useEffect, useState} from "react";
import { Alert, Autocomplete, Button , Box, Grid, Typography, TextField } from "@mui/material";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';

import "./AuctionForm.css"
import {getFrom, patchTo, postTo} from "../../data/api";
import { useNavigate } from "react-router-dom";

function AuctionForm() {
    const [categories, setCategories] = useState([]);

    const [pictures, setPictures] = useState([]);
    const [previewPic, setPreviewPic] = useState(null);
    const [title, setTitle] = useState(null);
    const [description, setDescription] = useState(null);
    const [startAt, setStartAt] = useState(null);
    const [endAt, setEndAt] = useState(null);
    const [type, setType] = useState(null);
    const [category, setCategory] = useState(null);
    const [price, setPrice] = useState(null);
    const [offerType, setOfferType] = useState(null);

    const typeList = [
        { label: 'Otevřená', name: "OPEN" },
        { label: 'Uzavřená', name: "CLOSED" },
    ]

    const offerTypeList = [
        { label: 'Poptávka', name: "DEMAND" },
        { label: 'Nabídka', name: "OFFER" },
    ]

    const [errors, setErrors] = useState([]);
    let navigate = useNavigate();

    const checkFileCount = (e) => {
        const picturesOpenDialog = document.getElementById("picturesOpenDialog");

        if (picturesOpenDialog.files.length > 12) {
            alert("Maximum obrázků je 12!");
        }

        setPictures(Array.from(picturesOpenDialog.files));
    }

    const validate = () => {
        const errs = [];
        if (title == null){
            errs.push({severity: "warning", msg:"Není nastaven 'Nadpis'"});
        }
        if (description == null){
            errs.push({severity: "warning", msg:"Není nastaven 'Popis'"});
        }
        if (price == null){
            errs.push({severity: "warning", msg:"Není nastaven 'Počáteční cena'"});
        }
        if (startAt == null){
            errs.push({severity: "warning", msg:"Není nastaven 'Začátek aukce'"});
        }
        if (endAt == null){
            errs.push({severity: "warning", msg:"Není nastaven 'Konec aukce'"});
        }
        if (type == null){
            errs.push({severity: "warning", msg:"Není nastaven 'Typ aukce'"});
        }
        if (previewPic == null){
            errs.push({severity: "warning", msg:"Není nastaven 'Náhledový obrázek'"});
        }
        if (category == null){
            errs.push({severity: "warning", msg:"Není nastavena 'Categorie'"});
        }
        if (offerType == null){
            errs.push({severity: "warning", msg:"Není nastaven 'Styl aukce'"});
        }

        setErrors(errs);

        if (errs.length > 0)
            return false;
        return true;
    }

    const Send = async () => {
        if (!validate())
            return;

        let previewPicId = null;
        let picturesIds = [];

        for (let i = 0; i < pictures.length; i++){
            const fd = new FormData();
            fd.append('image', pictures[i]);
            const res = await postTo('/pictures', fd);
            if (res.status != 200) {
                let errs = [...errors];
                errs.push({severity: "error", msg: `Obrázek ${pictures[i].name} se nepodařilo nahrát na server!`})
                setErrors([...errs])
                continue;
            }

            picturesIds.push(res.data.id);
            if (pictures[i].name === previewPic.name){
                previewPicId = res.data.id;
            }
        }

        if (previewPicId == null) {
            let errs = [...errors];
            errs.push({severity: "error", msg: `Obrázek ${previewPic.name} (náhledový) se nepodařilo nahrát na server!`})
            setErrors([...errs])
            return;
        }

        let auction = {}
        auction.title = title;
        auction.description = description;
        auction.startPrice = Number(price);
        auction.startAt = startAt;
        auction.endAt = endAt;
        auction.status = "UNCONFIRMED";
        auction.type = type.name;
        auction.categoryID = category.id;
        auction.offerType = offerType.name;

        const resAuction = await postTo('/auctions', auction);
        if (resAuction.status != 200) {
            let errs = [...errors];
            errs.push({severity: "error", msg: `Auckci se nepodařilo založi.`})
            setErrors([...errs])
            return;
        }

        auction = resAuction.data;

        const resPrevPicAuction = await patchTo(`/auctions/${auction.id}/previewPicture/${previewPicId}`);
        if (resPrevPicAuction.status != 200) {
            let errs = [...errors];
            errs.push({severity: "error", msg: `Náhledový obrázek ${previewPic.name} se nepodařilo přiřadit k aukci!`})
            setErrors([...errs])
        }

        for(let i = 0; i < picturesIds.length; i++) {
            const resPicAuction = await patchTo(`/pictures/${picturesIds[i]}/auction/${auction.id}`);
            if (resPicAuction.status != 200) {
                let errs = [...errors];
                errs.push({severity: "error", msg: `Obrázek ${previewPic.name} se nepodařilo přiřadit k aukci!`})
                setErrors([...errs])
            }
        }


        let errs = [...errors];
        errs.push({severity: "success", msg: `Aukce byla úspěšně vytvořena.`})
        setErrors([...errs])

        navigate(`/auctions/${auction.id}`)
    }

    useEffect(()=>{
        getFrom('/categories').then((res)=>{
            setCategories(res.data);
        }).catch((e)=>{
        console.error(e);
        })
    },[])

    return (
    <Box className="container">
        <Grid container direction={"column"} spacing={1}>

            <Grid item>
                <Grid container direction={"column"} spacing={1}>
                    {errors.map((err) => (
                        <Grid item>
                            <Alert severity={err.severity}>{err.msg}</Alert>
                        </Grid>
                    ))}
                </Grid>
            </Grid>

            <Grid item>
                <Typography 
                    variant="h3" 
                    component="div" 
                    className="auctionTitle"
                    >
                    Nová aukce
                </Typography>
            </Grid>

            <Grid item>
                <TextField 
                    label="Nadpis" 
                    variant="outlined" 
                    onChange={(e) => {
                        if (e.target.value === "")
                            setTitle(null)
                        else
                            setTitle(e.target.value)
                    }}
                    className="field"
                />
            </Grid>

            <Grid item>
                <TextField 
                    label="Popis" 
                    variant="outlined" 
                    multiline
                    rows={5}
                    onChange={(e) => {
                        if (e.target.value === "")
                            setDescription(null)
                        else
                            setDescription(e.target.value)
                    }}
                    className="field"
                />
            </Grid>

            <Grid item>
                <TextField 
                    label="Počáteční cena" 
                    variant="outlined" 
                    type="number"
                    onChange={(e) => {
                        if (e.target.value === "")
                            setPrice(null); 
                        else
                            setPrice(e.target.value); 
                    }}
                    className="field"
                />
            </Grid>

            <Grid item>
                <Grid container spacing={{xs:1,sm:1}}  columns={{ xs: 1, sm: 2}}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>

                        <Grid item xs={1} sm={1} >
                            <DateTimePicker 
                                label="Začátek aukce"
                                value={startAt}
                                onChange={setStartAt}
                                renderInput={(params) => <TextField {...params} className="fieldsDate"/> }
                            />
                        </Grid>

                        <Grid item xs={1} sm={1} >
                            <DateTimePicker 
                                label="Konec aukce"
                                value={endAt}
                                onChange={setEndAt}
                                renderInput={(params) => <TextField {...params} className="fieldsDate"/> }
                            />
                        </Grid>
            
                    </LocalizationProvider>
                </Grid>
            </Grid>

            <Grid item>
                <Button variant="contained" component="label" size="large" className="field">
                    Nahrát obrázky 
                    <input type="file" multiple hidden 
                    id="picturesOpenDialog"
                    accept="image/*"
                    onChange={checkFileCount}/>
                </Button>
            </Grid>

            <Grid item>
                <ImageList 
                    sx={{height: 300, border: 1, borderRadius: '5px', borderColor: 'lightgray' }}
                    cols={4}
                    className="field"
                    >
                    {pictures.map((pic) => (
                        <ImageListItem key={pic.name}>
                        <img src={URL.createObjectURL(pic)} />
                        <ImageListItemBar title={pic.name} />
                        </ImageListItem>
                    ))}
                </ImageList>
            </Grid>

            <Grid item>
                <Grid container spacing={{xs:1,sm:1,md:1}}  columns={{ xs: 1, sm: 2, md: 3, lg: 4}}>
                    
                    <Grid item xs={1} sm={1} md={1} lg={1}>
                        <Autocomplete
                            disablePortal
                            options={pictures}
                            getOptionLabel={(opt) => opt.name}
                            onChange={(e,v) => setPreviewPic(v)}
                            renderInput={(params) => <TextField {...params}  label="Náhledový obrázek"/>}
                        />
                    </Grid>

                    <Grid item xs={1} sm={1} md={1} lg={1}>
                        <Autocomplete
                            disablePortal
                            options={typeList}
                            onChange={(e,v) => setType(v)}
                            renderInput={(params) => <TextField {...params}  label="Typ aukce"/>}
                        />
                    </Grid>

                    <Grid item xs={1} sm={1} md={1} lg={1}>
                        <Autocomplete
                            disablePortal
                            options={categories}
                            getOptionLabel={(option) => option.title}
                            onChange={(e,v) => setCategory(v)}
                            renderInput={(params) => <TextField {...params} label="Kategorie"/>}
                        />
                    </Grid>

                    <Grid item xs={1} sm={1} md={1} lg={1}>
                        <Autocomplete
                            disablePortal
                            options={offerTypeList}
                            onChange={(e,v) => setOfferType(v)}
                            renderInput={(params) => <TextField {...params} label="Styl aukce"/>}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid item>
                <Button 
                    variant="contained" 
                    color="success"
                    className="field"
                    onClick={Send}
                    >
                        Vytvořit
                </Button>

            </Grid>
        </Grid>
    </Box>
    );
}

export default AuctionForm;